import { render, staticRenderFns } from "./SalesChart.vue?vue&type=template&id=6926055a&scoped=true"
import script from "./SalesChart.vue?vue&type=script&lang=js"
export * from "./SalesChart.vue?vue&type=script&lang=js"
import style0 from "./SalesChart.vue?vue&type=style&index=0&id=6926055a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6926055a",
  null
  
)

export default component.exports